<style lang="scss">
  .cartContent {
    .dataGrid {
      display: grid;
      grid-template-columns: 1fr;
      grid-gap: 15px;
      margin: 70px 0;
      a {
        margin-bottom: 40px;
      }
    }
    #fizetesi-mod {
      margin-bottom: 0;
      &.hasError {
        color: #DF3132;
      }
    }
    .companyDiv,
    .billingDiv {
      height: 0;
      -webkit-transition: all .3s ease-in-out;
      -moz-transition: all .3s ease-in-out;
      -ms-transition: all .3s ease-in-out;
      -o-transition: all .3s ease-in-out;
      transition: all .3s ease-in-out;
      overflow: hidden;
    }
    .ascompanyCheckboxWr {
      margin-bottom: 70px;
      &.ascVisible {
        height: 24px
      }
    }
    .companyDiv.cdVisible {
      padding-top: 30px;
      height: 190px
    }
    .billingDiv.bdVisible {
      padding-top: 30px;
      height: 600px
    }
    .formBottomGrid {
      .btn {
        width: 100%;
        margin: 10px 0;
      }
    }
    @media (min-width: 768px) {
      .dataGrid {
        grid-template-columns: 150px 1fr 110px;
        grid-gap: 30px;
        a {
          text-align: right;
        }
      }
      .companyDiv.cdVisible {
        height: 98px
      }
      .billingDiv.bdVisible {
        height: 294px
      }
      .formBottomGrid {
        margin-top: 70px;
        display: grid;
        grid-template-columns: 1fr 260px;
        .btn {
          width: 260px;
          margin: 0;
        }
      }
    }
    @media (min-width: 992px) {
      .dataGrid {
        grid-template-columns: 300px 1fr 110px;
      }
    }
  }
</style>
<template>
  <div class="cartContent">
    <FrontendNav></FrontendNav>
    <div class="container">
      <h1>Fizetés</h1>
      <p class="orderProgress">
        <span>Rendelés adatok</span> <i></i> <span class="active">Fizetés</span> <i></i> <span>Összegzés</span>
      </p>
      <form>
        <div class="dataGrid">
          <strong>Könyv(ek)</strong>
          <span>
            <template v-for="(book, index) in books">
              {{book.title}}<template v-if="index !== books.length-1">, </template>
            </template>
          </span><a href="/kosar">Módosítás</a>
          <strong>Szállítási adatok</strong><span>{{orderForm.lastname}} {{orderForm.firstname}}, {{orderForm.email}}, {{orderForm.tel}}</span><a href="/rendeles/adatok">Módosítás</a>
          <strong>Szállítási mód</strong><span>{{shippingText}}<template v-if="this.orderForm.shipping === 3">: {{orderForm.fpAddress}}</template></span><a href="/rendeles/adatok#szallitasi-mod">Módosítás</a>
          <strong class="text-primary">Bruttó végösszeg</strong><strong class="text-primary">{{cartSumPrice}} Ft</strong>
        </div>
        <p class="errors" v-if="fieldErrors.length">Kérjük, adja meg az alábbi mezőket: <span v-for="(error, index) in fieldErrors" :key="index">{{ error }}</span></p>
        <p id="fizetesi-mod" v-bind:class="{ hasError: errors.payment_method }"><strong>Válasszon fizetési módot:</strong></p>
        <div class="custom-control custom-radio">
          <input type="radio" id="barion" name="payment_method" value="barion" v-model="orderForm.payment_method" @change="pmChange" class="custom-control-input">
          <label class="custom-control-label" for="barion"><strong>Bankkártyás fizetés</strong><br>a BARION rendszerén keresztül</label>
        </div>
        <p style="margin-bottom: 20px"><strong>Számlázási adatok</strong></p>
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input" id="sbSame" v-model="sbSame" checked>
          <label class="custom-control-label" for="sbSame">Számlázási adataim megegyeznek, a szállítási adataimmal</label>
        </div>
        <div class="ascompanyCheckboxWr">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="ascompany" v-model="ascompany">
            <label class="custom-control-label" for="ascompany">Cégként vásárolok</label>
          </div>
        </div>
        <div class="row companyDiv" v-bind:class="{ cdVisible: ascompany}">
          <div class="col-sm-6">
            <div class="form-group floating" v-bind:class="{ hasError: errors.company_name }">
              <input type="text" class="form-control" id="company_name" v-model="paymentForm.company_name" v-bind:class="{'hasValue': paymentForm.company_name !== ''}">
              <label for="company_name">Cégnév</label>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group floating" v-bind:class="{ hasError: errors.taxnum }">
              <input type="text" class="form-control" id="taxnum" v-model="paymentForm.taxnum" v-bind:class="{'hasValue': paymentForm.taxnum !== ''}">
              <label for="taxnum">Adószám</label>
            </div>
          </div>
        </div>
        <div class="billingDiv" v-bind:class="{ bdVisible: !sbSame}">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group floating" v-bind:class="{ hasError: errors.address }">
                <input type="text" class="form-control" id="lastname" v-model="paymentForm.billing_lastname" v-bind:class="{'hasValue': paymentForm.billing_lastname !== ''}">
                <label for="lastname">Vezetéknév</label>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group floating" v-bind:class="{ hasError: errors.address }">
                <input type="text" class="form-control" id="firstname" v-model="paymentForm.billing_firstname" v-bind:class="{'hasValue': paymentForm.billing_firstname !== ''}">
                <label for="firstname">Keresztnév</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group floating" v-bind:class="{ hasError: errors.address }">
                <input type="text" class="form-control" id="country" v-model="paymentForm.billing_country" v-bind:class="{'hasValue': paymentForm.billing_country !== ''}">
                <label for="country">Ország</label>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group floating" v-bind:class="{ hasError: errors.address }">
                <input type="text" class="form-control" id="zip" v-model="paymentForm.billing_zip" v-bind:class="{'hasValue': paymentForm.billing_zip !== ''}">
                <label for="zip">Irányítószám</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group floating" v-bind:class="{ hasError: errors.address }">
                <input type="text" class="form-control" id="city" v-model="paymentForm.billing_city" v-bind:class="{'hasValue': paymentForm.billing_city !== ''}">
                <label for="city">Város</label>
              </div>
            </div>
            <div class="col-sm-6">
            <div class="form-group floating" v-bind:class="{ hasError: errors.address }">
              <input type="text" class="form-control" id="address" v-model="paymentForm.billing_address" v-bind:class="{'hasValue': paymentForm.billing_address !== ''}">
              <label for="address">Utca, házszám</label>
            </div>
          </div>
          </div>
        </div>
        <div class="formBottomGrid">
          <div><a href="/rendeles/adatok" class="btn btn-outline">Vissza</a></div>
          <div><a href="/rendeles/osszegzes" class="btn btn-primary" @click="validate($event)">Rendelés küldése</a></div>
        </div>
      </form>
    </div>
    <FrontendFooter></FrontendFooter>
  </div>
</template>

<script>
import FrontendNav from '../partials/nav'
import FrontendFooter from '../partials/footer'

var VueScrollTo = require('vue-scrollto')

export default {
  name: 'OrderPayment',
  components: {
    FrontendNav,
    FrontendFooter
  },
  data: function () {
    return {
      fieldErrors: [],
      errors: {
        payment_method: false,
        company_name: false,
        taxnum: false,
        billing_lastname: false,
        billing_firstname: false,
        billing_country: false,
        billing_zip: false,
        billing_city: false,
        billing_address: false
      },
      sbSame: true,
      ascompany: false,
      paymentForm: {
        payment_method: '',
        company_name: '',
        taxnum: '',
        billing_lastname: '',
        billing_firstname: '',
        billing_country: '',
        billing_zip: '',
        billing_city: '',
        billing_address: ''
      },
      shippingText: ''
    }
  },
  created: function () {
    let url = process.env.API_URL + '/' + process.env.API_ENDPOINT
    this.$http
      .get(url + `/shipment-methods `, {
        'headers': {
          'language': this.$store.state.loading.language
        }
      }).then(res => {
        for (let i = 0; i < res.data.data.length; i++) {
          if (res.data.data[i].id === this.orderForm.shipping) {
            this.shippingText = res.data.data[i].name
          }
        }
      }).catch(res => {
      })
  },
  computed: {
    orderForm: function () {
      return JSON.parse(localStorage.getItem('orderForm'))
    },
    books: function () {
      return JSON.parse(localStorage.getItem('cartItems'))
    },
    cartSumPrice: function () {
      return JSON.parse(localStorage.getItem('cartSumPrice'))
    }
  },
  methods: {
    validate: function (e) {
      e.preventDefault()
      this.fieldErrors = []
      for (let key in this.errors) {
        this.errors[key] = false
      }
      if (this.paymentForm.payment_method === '') {
        this.fieldErrors.push('fizetési mód')
        this.errors.payment_method = true
      }
      if (!this.sbSame) {
        if (this.paymentForm.billing_lastname === '') {
          this.fieldErrors.push('vezetéknév')
          this.errors.lastname = true
        }
        if (this.paymentForm.billing_firstname === '') {
          this.fieldErrors.push('keresztnév')
          this.errors.firstname = true
        }
        if (this.paymentForm.billing_country === '') {
          this.fieldErrors.push('ország')
          this.errors.country = true
        }
        if (this.paymentForm.billing_zip === '') {
          this.fieldErrors.push('irányítószám')
          this.errors.zip = true
        }
        if (this.paymentForm.billing_city === '') {
          this.fieldErrors.push('város')
          this.errors.city = true
        }
        if (this.paymentForm.billing_address === '') {
          this.fieldErrors.push('utca, házszám')
          this.errors.address = true
        }
      }
      if (this.ascompany) {
        if (this.paymentForm.company_name === '') {
          this.fieldErrors.push('cégnév')
          this.errors.company_name = true
        }
        if (this.paymentForm.taxnum === '') {
          this.fieldErrors.push('adószám')
          this.errors.taxnum = true
        }
      }
      if (this.fieldErrors.length > 0) {
        VueScrollTo.scrollTo('.dataGrid')
      } else {
        let postObject = {}
        let orderForm = JSON.parse(localStorage.getItem('orderForm'))
        let cartItems = JSON.parse(localStorage.getItem('cartItems'))
        postObject.shipping_name = orderForm.lastname + ' ' + orderForm.firstname
        postObject.shipping_country = orderForm.country
        postObject.shipping_zip = orderForm.zip
        postObject.shipping_city = orderForm.city
        postObject.shipping_street = orderForm.address
        postObject.shipping_number = '1'
        if (this.sbSame) {
          postObject.billing_name = orderForm.lastname + ' ' + orderForm.firstname
          postObject.billing_country = orderForm.country
          postObject.billing_zip = orderForm.zip
          postObject.billing_city = orderForm.city
          postObject.billing_street = orderForm.address
          postObject.billing_number = '1'
        } else {
          postObject.billing_name = this.paymentForm.lastname + ' ' + this.paymentForm.firstname
          postObject.billing_country = this.paymentForm.country
          postObject.billing_zip = this.paymentForm.zip
          postObject.billing_city = this.paymentForm.city
          postObject.billing_street = this.paymentForm.address
          postObject.billing_number = '1'
        }
        postObject.email = orderForm.email
        postObject.phone = orderForm.tel
        postObject.shipment_method_id = orderForm.shipping
        if (orderForm.shipping === 3) {
          postObject.foxpost_id = orderForm.fpId
        }
        postObject.payment_method_id = '1'
        if (this.ascompany) {
          postObject.billing_company = this.paymentForm.company_name
          postObject.tax_number = this.paymentForm.taxnum
        } else {
          postObject.billing_company = ''
          postObject.tax_number = ''
        }
        postObject.items = []
        for (let i = 0; i < cartItems.length; i++) {
          postObject.items.push({book_id: cartItems[i].id, quantity: cartItems[i].amount})
        }
        // console.log(postObject)
        let url = process.env.API_URL + '/' + process.env.API_ENDPOINT
        this.$http
          .post(url + `/order`, postObject).then(res => {
            console.log(res.data)
            window.location.href = res.data.data.pay_link
          }).catch(res => {
          })
        /* const parsed = JSON.stringify(this.paymentForm)
        localStorage.setItem('paymentForm', parsed)
        window.location.href = '/rendeles/fizetes' */
      }
    },
    pmChange: function () {
      this.paymentForm.payment_method = !this.paymentForm.payment_method
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/frontend/order/payment.vue